import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { Image_Fragment } from "./image";

export const MediaImage_Fragment = graphqlShopifyStorefront(
  `
  fragment MediaImage on MediaImage {
    __typename
    alt
    id
    imageMasked: image {
      ...Image
    }
    mediaContentType
    previewImageMasked: previewImage {
      ...Image
    }
  }
`,
  // [Image_Fragment],
);
